import { EntityCreationFact, SchemaFact } from "../../Dashboard/types";

// Whether a draft creation fact carries no real value. Handles both scalar
// facts ({ value }) and array facts ({ values }); whitespace-only scalars and
// arrays of all-empty items count as empty.
export function isFactValueEmpty(
  fact: EntityCreationFact | null | undefined
): boolean {
  if (!fact) return true;

  if (fact.values !== undefined) {
    // Array field: empty if no items, or all items have empty scalar AND null entity
    return (
      !fact.values ||
      fact.values.length === 0 ||
      fact.values.every(
        (v) =>
          (v.scalar === null ||
            (typeof v.scalar === "string" && v.scalar.trim() === "")) &&
          v.entity === null
      )
    );
  }

  if (fact.value !== undefined) {
    if (!fact.value) return true;
    const scalarEmpty =
      fact.value.scalar === null ||
      (typeof fact.value.scalar === "string" &&
        fact.value.scalar.trim() === "");
    const entityEmpty = fact.value.entity === null;
    return scalarEmpty && entityEmpty;
  }

  return true;
}

// Names of the required schema fields that have no value in the current draft.
// Drives both the create-blocked check and which fields to highlight. Optional
// fields (e.g. a connector-populated "Bipsync ID") are never included.
export function missingRequiredFactNames(
  schemaDefinitions: SchemaFact[],
  facts: Record<string, EntityCreationFact | null | undefined>
): string[] {
  return schemaDefinitions
    .filter((def) => def.is_required)
    .filter((def) => isFactValueEmpty(facts[def.name]))
    .map((def) => def.name);
}
